import { P2TextDescription } from "react-bootstrap-common-script";
import { TextSubheader } from "../../components/text/text-subheader";
import ApplicationCooLayout from "../../layout/application-coo-layout";
import { useAppSelector } from "../../redux/hook";
import { unescape } from "lodash";
import { useMemo } from "react";
import moment from "moment";
function ApplicationCancelled() {
  const applicationDetails = useAppSelector(state => state.app.ApplicationCancelledSlice).application_details;
  const cancelledBy = useAppSelector(state => state.app.ApplicationCancelledSlice.cancelled_by);
  const { date, time } = useMemo(() => {
    if(applicationDetails?.last_updated_at){
      return {date: moment(applicationDetails.last_updated_at).format('DD MMMM yyyy'), time: moment(applicationDetails.last_updated_at).format('h:mma')}
    }else{
      return {date: moment().format('DD MMMM yyyy'), time: moment().format('h:mma')}
    }
    
  }, [applicationDetails])
  const action = useMemo(() => {
      if(applicationDetails?.code === "UNREJECT" || applicationDetails?.application_status?.toLowerCase().includes("reject")){
        return "rejected";
      }else{
        return "cancelled";
      }
  }, [applicationDetails?.code])
  
  return (
    <ApplicationCooLayout>
      <div className='polymer-application-coo__wrapper'>
        <TextSubheader
          subheaderMain="Cancelled Application"
          subheaderSub={applicationDetails?.address}
          paddingLeftRight={42}
        />
        <div className="polymer-application-cancelled-container">
          <P2TextDescription size='1.375rem' color='#fff' title={"Updates on Application"}/>
          <div className="polymer-application-cancelled-content">
            <p className="polymer-application-cancelled-content-second">Your application has been {action}</p>
            {cancelledBy === "owner" ? 
               <p>The cancellation was made {applicationDetails?.updated_by ?? ""} on {date}, {time}. Please submit a new application if you wish to proceed with a change in flat ownership.</p> :
               <div style={{wordBreak: "break-word", fontSize: "1.125rem"}}>
                <p style={{marginBottom: "1rem"}}>
                  The application have been {action} on {date}, {time} due to the following reason:
                </p>
                <p style={{marginBottom: "1rem"}}>
                  {unescape(applicationDetails?.cancellation_reason) ?? ""}
                </p>
               </div>
            }
           
          </div>
        </div>
      </div>
    </ApplicationCooLayout>
  )
}

export default ApplicationCancelled;